var utility = {
	required(val) {
		return val === undefined || val === null || val === "" ? false : true;
	},

	form(form) {
		var self = this;

		this.elements = function() {
			form =
				typeof form == "string" ? document.querySelector(form) : form;

			if (form) {
				return form.querySelectorAll("input,textarea,select");
			}

			return [];
		};

		this.isValidPersianDate = function(value) {
			return /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/.test(
				value
			);
		};

		this.errors = function() {
			var errors = [];

			var isEmpty = function(value) {
				return (
					value === undefined ||
					value === null ||
					value === "" ||
					value.toString().trim() === ""
				);
			};

			var isValidNationalCode = function(value) {
				if (
					!/^\d{10}$/.test(value) ||
					value === "0000000000" ||
					value === "1111111111" ||
					value === "2222222222" ||
					value === "3333333333" ||
					value === "4444444444" ||
					value === "5555555555" ||
					value === "6666666666" ||
					value === "7777777777" ||
					value === "8888888888" ||
					value === "9999999999"
				) {
					return false;
				}

				var check = parseInt(value[9], 10);
				var sum = 0;
				var i;
				for (i = 0; i < 9; i++) {
					sum += parseInt(value[i], 10) * (10 - i);
				}
				sum %= 11;

				return (
					(sum < 2 && check === sum) ||
					(sum >= 2 && check + sum === 11)
				);
			};

			var isValidMobile = function(value) {
				return /09\d{9}$/.test(value);
			};

			var isValidPersianDate = function(value) {
				return /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/.test(
					value
				);
			};

			var isValidTime = function(value) {
				return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(value);
			};

			self.elements().forEach(function(el) {
				var validationTypes =
					JSON.parse(el.getAttribute("data-validations")) || [];
				var label = el.getAttribute("data-label");
				var value = "";

				if (
					self.isTextInput(el) ||
					self.isPasswordInput(el) ||
					self.isColorInput(el) ||
					self.isNumberInput(el) ||
					self.isHiddenInput(el) ||
					self.isTextarea(el)
				)
					value = el.value;

				if (self.isCheckBoxInput(el)) {
					value = el.checked ? "true" : "";
				}

				if (self.isDropDown(el)) {
					if (el.selectedOptions.length > 0)
						value = el.selectedOptions[0].value;
				}

				for (var i = 0; i < validationTypes.length; i++) {
					switch (typeof validationTypes[i]) {
						case "string":
							switch (validationTypes[i]) {
								case "required":
									if (isEmpty(value))
										errors.push({
											type: "validation.required",
											label: label,
											value: value
										});
									break;

								case "postalcode":
									if (!isEmpty(value) && value.length != 10)
										errors.push({
											type: "validation.invalid",
											label: label,
											value: value
										});
									break;

								case "nationalcode":
									if (
										!isEmpty(value) &&
										!isValidNationalCode(value)
									)
										errors.push({
											type: "validation.invalid",
											label: label,
											value: value
										});
									break;

								case "mobile":
									if (
										!isEmpty(value) &&
										!isValidMobile(value)
									)
										errors.push({
											type: "validation.invalid",
											label: label,
											value: value
										});
									break;

								case "persiandate":
									if (
										!isEmpty(value) &&
										!isValidPersianDate(value)
									)
										errors.push({
											type: "validation.invalid",
											label: label,
											value: value
										});
									break;

								case "time":
									if (!isEmpty(value) && !isValidTime(value))
										errors.push({
											type: "validation.invalid",
											label: label,
											value: value
										});
									break;

								case "password2":
									if (!isEmpty(value) && value.length < 8)
										errors.push({
											type: "validation.password2",
											label: label,
											value: value
										});
									break;
							}
							break;

						case "object":
							break;
					}
				}
			});

			return errors;
		};

		this.get = function() {
			var json = {};

			self.elements().forEach(function(el) {
				var name = el.getAttribute("data-name") || el.name;

				if (self.elementType().isDropDown(el)) {
					if (el.selectedOptions.length > 0) {
						if (el.selectedOptions.length == 1) {
							json[name] = el.selectedOptions[0].value;
						} else {
							var arr = [];
							for (var i = 0; i < el.selectedOptions.length; i++)
								arr.push(el.selectedOptions[i].value);
							json[name] = arr;
						}
					}
					return;
				}

				if (
					self.elementType().isTextInput(el) ||
					self.elementType().isPasswordInput(el) ||
					self.elementType().isColorInput(el) ||
					self.elementType().isNumberInput(el) ||
					self.elementType().isHiddenInput(el) ||
					self.elementType().isTextarea(el)
				) {
					json[name] = el.value;
					return;
				}

				if (self.elementType().isCheckBoxInput(el)) {
					json[name] = el.checked;
				}
			});

			return json;
		};

		this.set = function() {
			self.elements().forEach(function(el) {
				var name = el.getAttribute("data-name") || el.name;

				if (json[name] == undefined) {
					return;
				}

				if (self.elementType().isDropDown(el)) {
					if (json[name] != null) {
						if (json[name].length == undefined) {
							for (var i = 0; i < el.options.length; i++) {
								if (
									el.options[i].value ===
									json[name].toString()
								) {
									el.selectedIndex = i;
									break;
								}
							}
						} else {
							for (var i = 0; i < el.options.length; i++) {
								for (var ii = 0; ii < json[name].length; ii++) {
									if (
										el.options[i].value ===
										json[name][ii].toString()
									) {
										el.options[i].selected = true;
										break;
									}
								}
							}
						}
					}

					return;
				}

				if (
					self.elementType().isTextInput(el) ||
					self.elementType().isPasswordInput(el) ||
					self.elementType().isColorInput(el) ||
					self.elementType().isNumberInput(el) ||
					self.elementType().isHiddenInput(el) ||
					self.elementType().isTextarea(el)
				) {
					el.value = json[name];
					return;
				}

				if (self.elementType().isCheckBoxInput(el)) {
					el.checked = json[name];
				}
			});
		};

		this.isDropDown = function(el) {
			return el.localName == "select";
		};

		this.isTextarea = function(el) {
			return el.localName == "textarea";
		};

		this.isTextInput = function(el) {
			return el.localName == "input" && el.type == "text";
		};

		this.isColorInput = function(el) {
			return el.localName == "input" && el.type == "color";
		};

		this.isNumberInput = function(el) {
			return el.localName == "input" && el.type == "number";
		};

		this.isNumberPassword = function(el) {
			return el.localName == "input" && el.type == "password";
		};

		this.isHiddenInput = function(el) {
			return el.localName == "input" && el.type == "hidden";
		};

		this.isCheckBoxInput = function(el) {
			return el.localName == "input" && el.type == "checkbox";
		};

		this.isPasswordInput = function(el) {
			return el.localName == "input" && el.type == "password";
		};
	},

	db() {
		this.select = function(name) {
			if (localStorage.getItem(name)) {
				return JSON.parse(localStorage.getItem(name));
			} else return null;
		};

		this.insert = function(name, value) {
			if (typeof value == "object") {
				value = JSON.stringify(value);
			}

			localStorage.setItem(name, value);
		};

		this.delete = function(name) {
			localStorage.removeItem(name);
		};
	}
};

export default utility;
